import React, { useState} from "react";
import { useDispatch } from "react-redux";
import { FormGroup, InputGroup, FormControl, Form } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import cx from 'classnames';
import styles from './msDynamicsInstanceView.module.scss';
import { validateInstance } from 'src/legacy/redux/actions/integrations/msDynamics.jsx';
import { localizedStrings } from 'src/localization/index.jsx';

const MsDynamicsInstanceView = (props) => {
  const dispatch = useDispatch();
  
  const [instanceUrl, setInstanceUrl] = useState("");
  const [errors, setErrors] = useState({});

  const localizedIntegrations = localizedStrings.components.integrations;
  const localizedMsDynamics = localizedStrings.components.integrations.ms_dynamics;

  const _handleFieldChange = (e) => {
    let value = e.target.value;
    setInstanceUrl(value);
  };

  const handleValidate = () => {
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    dispatch(validateInstance(instanceUrl))
      .then(response => {
        if (response.success) {
          props.handleAuthenticate(instanceUrl);
        } else {
          setErrors({ instanceUrl: localizedMsDynamics.url_error });
        }
      })
  };

  const validateForm = () => {
    const errors = {};
    if (!instanceUrl || instanceUrl.trim().length === 0) {
      errors['instanceUrl'] = localizedMsDynamics.url_error;
    }
    return errors;
  };

  return (
    <div>
      <div className={styles.authorize}>
        <h3>{localizedMsDynamics.activate.title}</h3>
        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(localizedMsDynamics.activate.sub_text) }} />
        <div className={styles.form}>
          <FormGroup className={cx(styles.formGroup)}>
            <InputGroup>
              <InputGroup.Text className={styles.start}>
                <span>{localizedMsDynamics.instance_url}</span>
              </InputGroup.Text>
              <FormControl
                type="text"
                placeholder={localizedMsDynamics.placeholder}
                value={instanceUrl}
                onChange={_handleFieldChange}
              />
            </InputGroup>
          </FormGroup>
          <Form.Text className={styles.helpText}>(e.g., https://yourdomain.dynamics.com)</Form.Text>
          {errors && errors.instanceUrl && (
            <div className={styles.errorMessage}>{errors.instanceUrl}</div>
          )}
        </div>
        <button
          className={styles.authButton} onClick={handleValidate} disabled={props.authenticating}
        >
          {props.authenticating ? `${localizedIntegrations.actions.authenticating}...` : localizedIntegrations.actions.authenticate}
        </button>
      </div>
    </div>
  );
};

export default MsDynamicsInstanceView;
